module.exports = __webpack_public_path__ + "media/chevrons/arrow-next-446d3880.svg";